import { gql } from 'graphql-request';

export default gql`
  fragment CTABlock on CTABlock {
    title
    body
    linkTitle
    link {
      type: __typename
      id
      ... on PageChooserBlock {
        page {
          url
        }
      }
      ... on URLBlock {
        url: value
      }
    }
  }
`;
